import styled from "styled-components";

const PageWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;

  box-sizing: border-box;
  padding: 40px 15px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 755px) {
    justify-content: flex-start;
  }
  position: relative;
`;
export default PageWrapper;
